import React, { forwardRef } from 'react'
import styled from 'styled-components'

import { NumberMap } from 'types/Common'

const SIZE_MAP: NumberMap = { large: 25, medium: 14, small: 10 }
const CONTAINER_SIZE_MAP: NumberMap = { large: 31, medium: 24, small: 20 }

type Props = {
  fontSize?: string
} & React.HTMLAttributes<HTMLSpanElement>

const BookmarkIcon = forwardRef<HTMLSpanElement, Props>(({ fontSize = 'medium', ...props }, ref) => {
  const size = SIZE_MAP[fontSize] ?? SIZE_MAP.medium
  const containerSize = CONTAINER_SIZE_MAP[fontSize] ?? CONTAINER_SIZE_MAP.medium
  return (
    <S.IconContainer ref={ref} $size={containerSize} {...props}>
      <img src="/img/bookmark.svg" alt="Bookmark" width={size} height={size} />
    </S.IconContainer>
  )
})

BookmarkIcon.displayName = 'BookmarkIcon'

export default BookmarkIcon

const S = {
  IconContainer: styled.span<{ $size: number }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: ${({ $size }) => $size}px;
    height: ${({ $size }) => $size}px;
    flex-shrink: 0;
  `
}
